import { useRouter } from 'next/router';

import mixpanel from 'mixpanel-browser';
import { useSWRConfig } from 'swr';

import { post } from '@/utils/client';

import type { UserType } from '@/types/userType';

import { LOGOUT, USER } from '@/routes/apiEndpoints';

const useLogout = () => {
    const { mutate } = useSWRConfig();
    const router = useRouter();

    const logout = async () => {
        try {
            await post(LOGOUT);
            await mutate<UserType>(USER, undefined);
            //reset mixpanel user
            mixpanel?.reset();
            //reset product fruits
            window?.productFruits?.services.destroy();
            router.push('/');
        } catch (e) {
            console.error(e);
            // Logout fail
        }
    };

    return { logout };
};

export default useLogout;
